import { useList } from '@pankod/refine-core'

// support task count
export const useSupportTasksCount = (support_id: string, status: string) => {
  return useList({
    resource: 'support_tasks',
    metaData: {
      fields: ['id', 'active', 'assignee_id', 'status'],
    },
    config: {
      hasPagination: false,
      filters: [
        {
          field: 'assignee_id',
          operator: 'eq',
          value: support_id,
        },
        {
          field: 'status',
          operator: 'eq',
          value: status,
        },
      ],
    },
    queryOptions: {
      enabled: !!support_id,
    },
  })
}

// permisison based on task_id
// export const usePermissionByTask = () => {
//   return
// }
